<template>
	<div class="out-cont">
		<ul class="el-upload-list el-upload-list--picture-card">
			<li
				tabindex="0"
				class="el-upload-list__item is-ready"
				v-for="(item, index) in fileList"
				:key="index"
			>
				<img
					:src="item.fileUrl"
					alt=""
					class="el-upload-list__item-thumbnail"
				/>

				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="preview(item)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<span class="el-upload-list__item-delete" @click="deleteUrl(item)">
						<i class="el-icon-delete"></i> </span
				></span>
			</li>
		</ul>
		<div class="el-upload el-upload--picture-card" @click="upOpen">
			<div class="icon">
				<i class="el-icon-plus"></i>
			</div>
		</div>

		<input
			type="file"
			@change="upAjax($event)"
			accept="image/*"
			ref="file"
			style="display: none"
		/>
		<el-dialog
			append-to-body
			:visible.sync="dialogVisible"
			@close="dialogVisible = false"
		>
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			upPath: `${this.$init.apis.default}`,
			dialogImageUrl: "",
			dialogVisible: false,
			fileList: [],
		};
	},
	mounted() {},
	methods: {
		deleteUrl(file) {
			this.fileList = this.fileList.filter((e) => {
				return e.key != file.key;
			});
			this.changeList(this.fileList);
		},
		preview(file) {
			this.dialogImageUrl = file.fileUrl;
			this.dialogVisible = true;
		},
		/**
		 * 更新
		 */
		changeList(fileList) {
			this.$emit("change", fileList);
		},
		/**
		 * 上传封装
		 */
		uploadFun(file, cellback) {
			const vm = this;

			/**
			 * 文件名称转全路径
			 * @param {*} name
			 * @returns
			 */
			const fileNameToUrl = (fileName) => {
				if (fileName) {
					return `https://aires.hollardchina.com.cn/${fileName}`;
				} else {
					return "";
				}
			};

			/**
			 * 获取七牛token
			 * @returns {string} qntoken 七牛token
			 */
			const getQntoken = async () => {
				let qntoken = "";
				await vm.$http
					.post("/qiniu/getAiresBuckettoken", {})
					.then(function (response) {
						if (response.data.header.code == "A1000") {
							qntoken = response.data.body.qntoken;
						} else {
							vm.$message.error(response.data.header.msg);
						}
					})
					.catch(function () {
						vm.$message.error("网络错误");
					});
				if (qntoken) {
					return qntoken;
				} else {
					throw new Error("error");
				}
			};

			/**
			 * 上传文件
			 * @param {*} file 文件
			 * @param {function} 回调
			 * @returns 文件对象
			 */
			const uploadFile = async (file, cellback) => {
				let token = "";
				await getQntoken()
					.then((qntoken) => {
						token = qntoken;
					})
					.catch(() => {
						cellback("error", false);
					});

				if (!token) {
					throw new Error("error");
				}

				if (!file.raw) {
					file.raw = file;
				}
				let fileNameArr = file.name.split(".");
				let fileName = uuid() + "." + fileNameArr.pop();

				const observable = await qiniu.upload(file.raw, fileName, token);
				await observable.subscribe({
					next(res) {
						// ...上传进度信息
					},
					error(err) {
						// ...上传错误后触发
						cellback(err, false);
						vm.loading = false;
					},
					complete(res) {
						// ...接收上传完成后的后端返回信息
						vm.loading = false;
						cellback(
							{
								...res,
								fileUrl: fileNameToUrl(res.key),
							},
							true
						);
					},
				});
			};

			uploadFile(file, cellback);
		},
		/**
		 * 上传触发
		 */
		upOpen() {
			this.$refs.file.click();
		},
		/**
		 * 图片转BASE64
		 */
		toView(file) {
			const vm = this;
			var reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function (e) {
				vm.BinaryImg = this.result;
			};
		},
		/**
		 * 上传服务
		 */
		upAjax(e) {
			const vm = this;
			let imgFile = e.target.files[0];
			if (!imgFile) {
				return;
			}

			vm.loading = true;

			this.uploadFun(imgFile, ({ key, fileUrl }) => {
				vm.loading = false;
				vm.fileList.push({ name: key, fileUrl: fileUrl });
				vm.changeList(vm.fileList);
			});
		},
		/**
		 * 更新图片地址
		 */
		upFile(url) {
			this.$emit("updata", url);
		},
	},
};
</script>

<style lang="scss" scoped></style>
